import {
  SOLUTION_TYPE,
  SolutionType,
  SolutionTypeFilter,
} from '../constants/user-info/solutionType';
import { apiService } from './apiService';

type GetUnreadScansSolutionType = Exclude<SolutionType, typeof SOLUTION_TYPE.CHALLENGE>;

export const unreadScansService = {
  async getUnreadScansCount(solutionType: GetUnreadScansSolutionType): Promise<number> {
    const response = await apiService.get(`/api/navigation/sidebar/badge-key/new-scans`, {
      params: { solutionType },
    });
    return response.data;
  },

  async markScanIqCustomerScanSeen(customerId: number): Promise<void> {
    await apiService.post(`/api/scan-iq/coach/inbody-data/${customerId}/mark-seen`);
  },

  async markNutritionCustomerScanSeen(customerId: number): Promise<void> {
    await apiService.post(`/api/coach/inbodydata/${customerId}/markseen`);
  },

  async markAllScansRead(solutionType: SolutionTypeFilter): Promise<void> {
    await apiService.put(
      `/api/home-page/required-attention/unread-scans/mark-read`,
      undefined,
      { params: { solutionType } },
    );
  },
};
